
export interface InfoCard { 
  title: string;
  value?: string;
  path?: string;
  iconColor?: string;
  iconBackgroundColor?: string;
  icon?: string;
  field?: string;
}